/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DateGrid extends SiteEntityGrid<DateRow, any> {
        protected getColumnsKey() { return 'Data.Date'; }
        protected getDialogType() { return DateDialog; }
        protected getIdProperty() { return DateRow.idProperty; }
        protected getLocalTextPrefix() { return DateRow.localTextPrefix; }
        protected getService() { return DateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}